import { render, staticRenderFns } from "./locationLogout.vue?vue&type=template&id=3d497dcf&"
import script from "./locationLogout.vue?vue&type=script&lang=js&"
export * from "./locationLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports